
export const setCookie = (name, value) => {
  let today = new Date();
  // expire in 30 days
  let expiry = new Date(today.getTime() + 30 * 24 * 3600 * 1000);
  document.cookie=name + "=" + escape(value) + "; path=/; expires=" + expiry.toGMTString();
}

export const getCookie = (name) => {
  let re = new RegExp(name + "=([^;]+)");
  let value = re.exec(document.cookie);
  return (value != null) ? unescape(value[1]) : null;
}

export const deleteCookie = (name) => {
  let today = new Date();
  let expired = new Date(today.getTime() - 24 * 3600 * 1000);
  document.cookie=name + "=null; path=/; expires=" + expired.toGMTString();
}